//
//
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

import {
  CAJA_ESTADOCUENTA,
  CAJA_GET_DESCUENTOSCATALOGO,
  CAJA_GET_DESCUENTOSXIDCUENTA,
  CAJA_GET_GSEQUIVALENTES,
  CAJA_GET_FORMASPAGOSAT,
  CAJA_GET_USOSCFDI40,
  CAJA_POST_ABONOACUENTA,
  CAJA_GET_RECIBOPAGO,
  CAJA_POST_ENVIORECIBO,
  CAJA_ALUMNOS,
  CAJA_GET_SERVICIOS,
  CAJA_GET_ULTIMOCARGO,
  CAJA_DEL_IDRELACIONDESCUENTOCARGO,
  CAJA_POST_ADDCARGO,
  CAJA_DEL_OCARGO,
  CAJA_GET_CONCEPTOSGASTO,
  CAJA_POST_ADDGASTO,
  CAJA_LINKPAGO,
  CAJA_LINKPAGO_MASIVO,
  CAJA_GET_GASTO,
  CAJA_DEL_GASTO,
  CAJA_GET_GASTOS,
} from "./actionTypes"

import {
  delCajaDeloCargoSuccess,
  delCajaDeloCargoFail,
  getCajaEstadoCuentaSuccess,
  getCajaEstadoCuentaFail,
  getCajaDescuentosCatalogoSuccess,
  getCajaDescuentosCatalogoFail,
  getCajaDescuentosxidCuentaSuccess,
  getCajaDescuentosxidCuentaFail,
  getCajaGSEquivalentesSuccess,
  getCajaGSEquivalentesFail,
  getCajaFormasPagoSATSuccess,
  getCajaFormasPagoSATFail,
  getCajaUsosCFDI40Success,
  getCajaUsosCFDI40Fail,
  postCajaAbonoaCuentaSuccess,
  postCajaAbonoaCuentaFail,
  getCajaReciboPagoSuccess,
  getCajaReciboPagoFail,
  postCajaEnvioReciboSuccess,
  postCajaEnvioReciboFail,
  getCajaAlumnosSuccess,
  getCajaAlumnosFail,
  getCajaServiciosSuccess,
  getCajaServiciosFail,
  getCajaUltimoCargoSuccess,
  getCajaUltimoCargoFail,
  delCajaDelIdRelacionDescuentoCargoSuccess,
  delCajaDelIdRelacionDescuentoCargoFail,
  postCajaAddCargoSuccess,
  postCajaAddCargoFail,
  getCajaConceptosGastoSuccess,
  getCajaConceptosGastoFail,
  postCajaAddGastoSuccess,
  postCajaAddGastoFail,
  setCajaMensajeExito,
  postCajaLinkPagoSuccess,
  postCajaLinkPagoFail,
  postCajaLinkPagoMasivoSuccess,
  postCajaLinkPagoMasivoFail,
  getCajaGastoSuccess,
  getCajaGastoFail,
  delCajaGastoSuccess,
  delCajaGastoFail,
  getCajaGastosSuccess,
  getCajaGastosFail,
} from "./actions"

import {
  getCajaEstadoCuenta,
  get_From_CajaController,
  post_CajaController,
  del_From_CajaController,
} from "../../helpers/campusvirtualbackend_helper"

// Función para obtener el valor de "Mensaje_Exito"
function getValueFromParametrosApi(response, Nombre) {
  // Verificar si el response tiene la propiedad 'Parametros'
  if (response.hasOwnProperty("Parametros") && response.Parametros) {
    console.log("response", response)
    // Buscar dentro del array 'Parametros' el response con Nombre 'Mensaje_Exito'
    const parametro = response.Parametros.find(item => item.Nombre === Nombre)

    if (parametro) {
      // Retornar el valor asociado a 'Mensaje_Exito'
      return parametro.Valor
    } else {
      // Manejo si 'Mensaje_Exito' no se encuentra
      return null
    }
  } else {
    // Manejo si 'Parametros' no existe en el response
    return null
  }
}
function* fetchEstadoCuenta({ payload: { jsonparameters } }) {
  try {
    const response = yield call(getCajaEstadoCuenta, jsonparameters)
    //console.log("fetchEstadoCuenta: ", response)
    yield put(getCajaEstadoCuentaSuccess(response))
    //
  } catch (error) {
    //
    //console.log("Eror: " + error)
    yield put(getCajaEstadoCuentaFail(error))

    //
  }
}
function* fetchAbonoaCuenta({ payload: { jsonparameters } }) {
  try {
    const response = yield call(post_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postCajaAbonoaCuentaFail(response.Mensaje_Detalle))
    } else {
      yield put(postCajaAbonoaCuentaSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchAbonoaCuenta: " + error)
    yield put(postCajaAbonoaCuentaFail(error))
  }
}
function* fetchDescuentosCatalogo({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCajaDescuentosCatalogoFail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchDescuentosCatalogo", response)
      yield put(getCajaDescuentosCatalogoSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchDescuentosCatalogo::Eror: ", error)
    yield put(getCajaDescuentosCatalogoFail(error))
  }
}
function* fetchDescuentosxidCuenta({ payload: { jsonparameters } }) {
  try {
    //
    const response = yield call(get_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCajaDescuentosxidCuentaSuccess(response.Mensaje_Detalle))
    } else {
      //console.log("fetchDescuentosxidCuenta", response)
      yield put(getCajaDescuentosxidCuentaSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchDescuentosxidCuenta::Eror: ", error)
    yield put(getCajaDescuentosxidCuentaFail(error))
  }
}
function* fetchGrupoServiciosEquivalentes({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCajaGSEquivalentesFail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchDescuentosxidCuenta", response)
      yield put(getCajaGSEquivalentesSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchGrupoServiciosEquivalentes>>Eror: " + error)
    yield put(getCajaGSEquivalentesFail(error))
  }
}
function* fetchFormasPagoSAT({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      //console.log("fetchFormasPagoSAT:failed: ", response)
      yield put(getCajaFormasPagoSATFail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchFormasPagoSAT::success ", response)
      yield put(getCajaFormasPagoSATSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchFormasPagoSAT::Eror: " + error)
    yield put(getCajaFormasPagoSATFail(error))
  }
}
function* fetchUsosCFDI40({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      //console.log("fetchUsosCFDI40:Fail: ", response)
      yield put(getCajaUsosCFDI40Fail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchUsosCFDI40:success ", response)
      yield put(getCajaUsosCFDI40Success(response.Datos))
    }
  } catch (error) {
    //console.log("fetchUsosCFDI40::Eror: " + error)
    yield put(getCajaUsosCFDI40Fail(error))
  }
}
function* fetchReciboPago({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      //console.log("fetchReciboPago:Fail: ", response)
      yield put(getCajaReciboPagoFail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchReciboPago:success ", response)
      yield put(getCajaReciboPagoSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchReciboPago::Eror: " + error)
    yield put(getCajaReciboPagoFail(error))
  }
}
function* fetchEnvioReciboPago({ payload: { jsonparameters } }) {
  try {
    const response = yield call(post_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      //console.log("fetchEnvioReciboPago:Fail: ", response)
      yield put(postCajaEnvioReciboFail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchEnvioReciboPago:success ", response)
      yield put(postCajaEnvioReciboSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchEnvioReciboPagoEror: " + error)
    yield put(postCajaEnvioReciboFail(error))
  }
}
function* fetchCajaAlumnos({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      //console.log("fetchCajaAlumnos:Fail: ", response)
      yield put(getCajaAlumnosFail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchCajaAlumnos:success: ", response)
      yield put(getCajaAlumnosSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchCajaAlumnos::Eror: " + error)
    yield put(getCajaAlumnosFail(error))
  }
}
function* fetchCajaServicios({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      //console.log("fetchCajaServicios:Fail: ", response)
      yield put(getCajaServiciosFail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchCajaServicios:success: ", response)
      yield put(getCajaServiciosSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchCajaServicios::Eror: " + error)
    yield put(getCajaServiciosFail(error))
  }
}
function* fetchCajaUltimoCargo({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      //console.log("fetchCajaServicios:Fail: ", response)
      yield put(getCajaUltimoCargoFail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchCajaUltimoCargo:success: ", response)
      yield put(getCajaUltimoCargoSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchCajaUltimoCargo::Eror: " + error)
    yield put(getCajaUltimoCargoFail(error))
  }
}
function* fetchCajaConceptosGasto({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      //console.log("fetchCajaServicios:Fail: ", response)
      yield put(getCajaConceptosGastoFail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchCajaUltimoCargo:success: ", response)
      yield put(getCajaConceptosGastoSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchCajaUltimoCargo::Eror: " + error)
    yield put(getCajaConceptosGastoFail(error))
  }
}
function* fetchCajaDelIdRelacionDescuentoCargo({
  payload: { jsonparameters },
}) {
  try {
    const response = yield call(del_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      //console.log("fetchCajaDelIdRelacionDescuentoCargo:Fail: ", response)
      yield put(
        delCajaDelIdRelacionDescuentoCargoFail(response.Mensaje_Detalle)
      )
    } else {
      //console.log("fetchCajaDelIdRelacionDescuentoCargo:success: ", response)
      yield put(delCajaDelIdRelacionDescuentoCargoSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchCajaDelIdRelacionDescuentoCargo::Eror: " + error)
    yield put(delCajaDelIdRelacionDescuentoCargoFail(error))
  }
}
function* fetchAddCargo({ payload: { jsonparameters } }) {
  try {
    const response = yield call(post_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postCajaAddCargoFail(response.Mensaje_Detalle))
    } else {
      yield put(postCajaAddCargoSuccess(response.Datos))
    }
  } catch (error) {
    yield put(postCajaAddCargoFail(error))
  }
}
function* fetchCajaDeloCargo({ payload: { jsonparameters } }) {
  try {
    const response = yield call(del_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      //console.log("fetchCajaDeloCargo:Fail: ", response)
      yield put(delCajaDeloCargoFail(response.Mensaje_Detalle))
    } else {
      //console.log("fetchCajaDeloCargo:success: ", response)
      yield put(delCajaDeloCargoSuccess(response.Datos))
    }
  } catch (error) {
    //console.log("fetchCajaDeloCargo::Eror: " + error)
    yield put(delCajaDeloCargoFail(error))
  }
}
function* fetchAddGasto({ payload: { jsonparameters } }) {
  try {
    const response = yield call(post_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postCajaAddGastoFail(response.Mensaje_Detalle))
    } else {
      yield put(postCajaAddGastoSuccess(response.Datos))
      // Si tiene un parámetro llamado "Mensaje_Exito", lo registra
      const MensajeExitoso = getValueFromParametrosApi(
        response,
        "Mensaje_Exito"
      )
      if (MensajeExitoso) {
        yield put(setCajaMensajeExito(MensajeExitoso))
      }
    }
  } catch (error) {
    yield put(postCajaAddGastoFail(error))
  }
}
function* fetchLinkPago({ payload: { jsonparameters } }) {
  try {
    const response = yield call(post_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postCajaLinkPagoFail(response.Mensaje_Detalle))
    } else {
      yield put(postCajaLinkPagoSuccess(response.Datos))
      // Si tiene un parámetro llamado "Mensaje_Exito", lo registra
      const MensajeExitoso = getValueFromParametrosApi(
        response,
        "Mensaje_Exito"
      )
      if (MensajeExitoso) {
        yield put(setCajaMensajeExito(MensajeExitoso))
      }
    }
  } catch (error) {
    yield put(postCajaLinkPagoFail(error))
  }
}
function* fetchLinkPagoMasivo({ payload: { jsonparameters } }) {
  try {
    const response = yield call(post_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postCajaLinkPagoMasivoFail(response.Mensaje_Detalle))
    } else {
      yield put(postCajaLinkPagoMasivoSuccess(response.Datos))
      // Si tiene un parámetro llamado "Mensaje_Exito", lo registra
      const MensajeExitoso = getValueFromParametrosApi(
        response,
        "Mensaje_Exito"
      )
      if (MensajeExitoso) {
        yield put(setCajaMensajeExito(MensajeExitoso))
      }
    }
  } catch (error) {
    yield put(postCajaLinkPagoMasivoFail(error))
  }
}
function* fetchCajaGasto({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCajaGastoFail(response.Mensaje_Detalle))
    } else {
      yield put(getCajaGastoSuccess(response.Datos))
      // Si tiene un parámetro llamado "Mensaje_Exito", lo registra
      const MensajeExitoso = getValueFromParametrosApi(
        response,
        "Mensaje_Exito"
      )
      if (MensajeExitoso) {
        yield put(setCajaMensajeExito(MensajeExitoso))
      }
    }
  } catch (error) {
    yield put(getCajaGastoFail(error))
  }
}
function* fetchCajaDelGasto({ payload: { jsonparameters } }) {
  try {
    const response = yield call(del_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(delCajaGastoFail(response.Mensaje_Detalle))
    } else {
      yield put(delCajaGastoSuccess(response.Datos))
      // Si tiene un parámetro llamado "Mensaje_Exito", lo registra
      const MensajeExitoso = getValueFromParametrosApi(
        response,
        "Mensaje_Exito"
      )
      if (MensajeExitoso) {
        yield put(setCajaMensajeExito(MensajeExitoso))
      }
    }
  } catch (error) {
    yield put(delCajaGastoFail(error))
  }
}
function* fetchCajaGastos({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CajaController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCajaGastosFail(response.Mensaje_Detalle))
    } else {
      yield put(getCajaGastosSuccess(response.Datos))
      // Si tiene un parámetro llamado "Mensaje_Exito", lo registra
      const MensajeExitoso = getValueFromParametrosApi(
        response,
        "Mensaje_Exito"
      )
      if (MensajeExitoso) {
        yield put(setCajaMensajeExito(MensajeExitoso))
      }
    }
  } catch (error) {
    yield put(getCajaGastosFail(error))
  }
}

function* CajaSaga() {
  yield takeEvery(CAJA_ESTADOCUENTA, fetchEstadoCuenta)
  yield takeEvery(CAJA_GET_DESCUENTOSCATALOGO, fetchDescuentosCatalogo)
  yield takeEvery(CAJA_GET_DESCUENTOSXIDCUENTA, fetchDescuentosxidCuenta)
  yield takeEvery(CAJA_GET_GSEQUIVALENTES, fetchGrupoServiciosEquivalentes)
  yield takeEvery(CAJA_GET_FORMASPAGOSAT, fetchFormasPagoSAT)
  yield takeEvery(CAJA_GET_USOSCFDI40, fetchUsosCFDI40)
  yield takeEvery(CAJA_POST_ABONOACUENTA, fetchAbonoaCuenta)
  yield takeEvery(CAJA_GET_RECIBOPAGO, fetchReciboPago)
  yield takeEvery(CAJA_POST_ENVIORECIBO, fetchEnvioReciboPago)
  yield takeEvery(CAJA_ALUMNOS, fetchCajaAlumnos)
  yield takeEvery(CAJA_GET_SERVICIOS, fetchCajaServicios)
  yield takeEvery(CAJA_GET_ULTIMOCARGO, fetchCajaUltimoCargo)
  yield takeEvery(CAJA_GET_CONCEPTOSGASTO, fetchCajaConceptosGasto)
  yield takeEvery(
    CAJA_DEL_IDRELACIONDESCUENTOCARGO,
    fetchCajaDelIdRelacionDescuentoCargo
  )
  yield takeEvery(CAJA_DEL_OCARGO, fetchCajaDeloCargo)
  yield takeEvery(CAJA_POST_ADDCARGO, fetchAddCargo)
  yield takeEvery(CAJA_POST_ADDGASTO, fetchAddGasto)
  yield takeLatest(CAJA_LINKPAGO, fetchLinkPago)
  yield takeLatest(CAJA_LINKPAGO_MASIVO, fetchLinkPagoMasivo)
  yield takeEvery(CAJA_GET_GASTO, fetchCajaGasto)
  yield takeEvery(CAJA_DEL_GASTO, fetchCajaDelGasto)
  yield takeEvery(CAJA_GET_GASTOS, fetchCajaGastos)
}

export default CajaSaga
